document.addEventListener('alpine:init', () => {
  Alpine.data('collection', (data) => ({
    filters: [],
    sort: data.sort,
    showMobileFilter: false,
    showFixedFilter: false,
    filtersValueTitleList: data.filtersValueTitleList,
    loading: false,
    imageType: 'sfeer',
    priceMin: '',
    priceMax: '',
    brand: '',
    page: 1,
    lang: document.getElementsByTagName('html')[0].getAttribute('lang'),
    init () {
      const url = new URL(window.location.href)
      const sortFromUrl = url.searchParams.get('sort')
      if (sortFromUrl) {
        this.sort = sortFromUrl
      }

      const imageType = sessionStorage.getItem('imageType')
      if (imageType) {
        this.imageType = imageType
      }
      this.getFiltersFromURL()
      
      this.$watch('filters', () => {
        const url = this.constructFiltersUrl()
        this.fetchAndReplaceProducts(url)
      })
      this.$watch('sort', () => {
        const url = this.constructFiltersUrl()
        this.fetchAndReplaceProducts(url)
      })
      this.$watch('brand', () => {
        const url = this.constructFiltersUrl()
        this.fetchAndReplaceProducts(url)
        this.customDatalayerEvent({
          event: 'filter_brand_set',
          brand: this.brand,
        })
      })
      this.$watch('imageType', () => {
        sessionStorage.setItem('imageType', this.imageType)
      })
    },
    constructFiltersUrl () {
      const url = new URL(window.location.origin + window.location.pathname)
      const params = this.constructSearchParams()
      return params ? url.toString() + '?' + params : url.toString()
    },
    constructAndFetch () {
      const url = this.constructFiltersUrl()
      this.fetchAndReplaceProducts(url)
    },
    constructSearchParams () {
      const params = new URLSearchParams()
      for (let index = 0; index < this.filters.length; index++) {
        const filter = this.filters[index];
        params.append('filter[]', filter)
      }
      if (this.sort !== 'popular') {
        params.set('sort', this.sort)
      }
      if (this.priceMin) { params.set('min', this.priceMin) }
      if (this.priceMax) { params.set('max', this.priceMax) }
      if (this.brand) { params.set('brand', this.brand) }
      return params.toString()
    },
    findFilterTitle (id) {
      const findFilter = this.filtersValueTitleList.find(el => el.id === id)
      let title = ''
      if (findFilter) {
        if (findFilter.title.includes('_')) {
          const split = findFilter.title.split('_')
          title = split[1]
        } else {
          title = findFilter.title
        }
      }
      return title
    },
    getFiltersFromURL () {
      const url = new URL(window.location.href)
      url.searchParams.forEach((value, key) => {
        if (key === 'filter[]') {
          this.filters.push(value)
        }
        if (key === 'brand') {
          this.brand = value
        }
        if (key === 'min') {
          this.priceMin = value
        }
        if (key === 'max') {
          this.priceMax = value
        }
      });
    },
    async fetchAndReplaceProducts (url) {
      if (this.priceMin || this.priceMax) {
        this.customDatalayerEvent({
          event: 'filter_price_set',
          price_min: this.priceMin,
          price_max: this.priceMax
        })
      }
      this.loading = true;
      const response = await fetch(url)
      const html = await response.text()
      const domparser = new DOMParser()
      const doc = domparser.parseFromString(html, "text/html")
      const producList = doc.querySelector("#product-list")
      document.querySelector("#product-list").innerHTML = producList.innerHTML
      window.history.pushState(undefined, undefined, url);
      this.loading = false;
    },
    removeFilter (id) {
      const index = this.filters.findIndex(el => el === id)
      this.filters.splice(index, 1)
      const foundEl = document.querySelector(`[for="${id}"]`)
      const parent = foundEl.closest('div[data-filter-title]')
      this.customDatalayerEvent({
        event: 'filter_untick',
        filter_value: this.findFilterTitle(id),
        filter_category: parent.getAttribute('data-filter-title')
      })
    },
    removeAllFilters () {
      for (let index = this.filters.length - 1; index >= 0; index--) {
        this.removeFilter(this.filters[index])
      }
    },
    customDatalayerEvent(obj) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(obj)
    }
  }))
})